import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

type TwoColumnProps = {
  children?: JSX.Element
  header?: JSX.Element
  colorLeft?: string
  colorRight?: string
}

const TwoColumnLayout = (props: TwoColumnProps) => {
  const { colorLeft, colorRight } = props;

  return (
    <Grid container sx={{ height: { lg: "100vh", xs: "100%" }, flexFlow: { xs: "column", lg: "row" } }}>
      {/* <Grid item xs={12} lg={4} sx={{ backgroundColor: "#111", color: "white" }}> */}
      {/* <Grid item xs={12} lg={4} sx={{ backgroundColor: "#40E0D0", color: "white" }}> */}
      {/* <Grid item xs={12} lg={4} sx={{ backgroundColor: "#1E90FF", color: "white" }}> */}
      <Grid item xs={12} lg={3} sx={{ backgroundColor: colorLeft || "#0B0B45", color: "white" }}>
        <Box 
          sx={{ 
            pl: "50px",
            pr: "50px",
            pb: "20px",
            pt: { xs: "20px", lg: "150px" },
            height: "100%", 
            width: "100%", 
            fontStyle: "italic", 
            textAlign: "left",
            lg: {
              pt: "0px",
            }
          }}
        >
          {props.header}
        </Box>
      </Grid>
      {/* <Grid item xs={12} lg={9} sx={{ background: "#40E0D0", color: "#0B0B45", height: "100%" }}> */}
      <Grid item xs={12} lg={9} sx={{ background: colorRight || "white", color: "#0B0B45", height: "100%" }}>
        <Box
          sx={{
            p: "20px",
            overflow: "scroll", 
            height: "100%",
            minHeight: "100vh",
            textAlign: "left",
          }}
        >
          {props.children}
        </Box>
      </Grid>
    </Grid>
  )
}

export default TwoColumnLayout;